import { render, staticRenderFns } from "./selection-control-panel.vue?vue&type=template&id=2167abda&scoped=true&"
import script from "./selection-control-panel.vue?vue&type=script&lang=js&"
export * from "./selection-control-panel.vue?vue&type=script&lang=js&"
import style0 from "./selection-control-panel.vue?vue&type=style&index=0&id=2167abda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167abda",
  null
  
)

export default component.exports